import { Observable } from 'rxjs';
import { DatosComercio } from 'src/app/global/interfaces/datos-comercio';
import { IdentificacionComercioResponse } from 'src/app/global/interfaces/identificacion-comercio-response';
import { LlamarCliente } from '../../global/interfaces/datos-comercio';


export abstract class DatosComercioServiceVM {
  abstract obtieneIdentificacionComercio(correo?: string): Observable<IdentificacionComercioResponse>;
  abstract registraDatosComercio(datosComercio: DatosComercio): Observable<any>;
  abstract obtieneLocalizaciones(): Observable<any>;
  abstract autenticacaComercio(run: number, tokenExterno: String): Observable<any>;
  abstract obtenerCartaPoder(): Observable<any>;
  abstract llamarCliente(llamarCliente: LlamarCliente): Observable<any>;
}
